import type { MsAdlActivityLabels } from "../en-GB/msAdlCopy";

export const msAdlCopyDe: MsAdlActivityLabels = {
    Walking: "Gehen",
    Cooking: "Kochen",
    Driving: "Autofahren",
    Shopping: "Einkaufen",
    Work: "Arbeit",
    Sport: "Sport",
    Housework: "Hausarbeit",
    Socialising: "Soziale Kontakte",
};
